import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const DataQualityWarningAssetFragmentGql: DocumentNode = gql`
fragment DataQualityWarningAssetFragment on DataQualityWarning {
  asset {
    id
    __typename
    ... on Flow {
      vizportalUrlId
      name
    }
    ... on PublishedDatasource {
      vizportalUrlId
      name
    }
    ... on Database {
      name
    }
    ... on DatabaseTable {
      name
    }
    ... on VirtualConnection @flag(enabled: $publishedConnectionsLineageEnabled) {
      name
    }
    ... on VirtualConnectionTable @flag(enabled: $publishedConnectionsLineageEnabled) {
      name
    }
  }
}
`;
